module.exports = __webpack_public_path__ + "media/Video 82.7306a4dc.mp4";